<template>
  <OverviewTeasersFi
    :fields="fields"
    :api-url="apiUrl"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import OverviewTeasersFi from '@/components/overview-teasers-fi/OverviewTeasersFi.vue';
import type { TeaserOverviewFiFields } from '@/generated/fields';

defineOptions({ name: 'TeaserOverviewFi' });

withDefaults(
  defineProps<{
    fields?: TeaserOverviewFiFields;
  }>(),
  {
    fields: () => ({}) as TeaserOverviewFiFields,
  },
);

const apiUrl = computed(() => {
  if (IS_SHOWROOM) {
    return '/__mocks__/sitecoreApi/api/teaser/get/mockedTeaserData.json';
  }

  return '/api/teaser/get';
});
</script>

<style scoped src="./teaser-overview-fi" />
